import React from "react";
import "./Testimonials.css";

const testimonials = [
  {
    quote:
      "I loved the customer service you guys provided me. That was very nice and patient with questions I had. I would really like definitely come back here",
    name: "Paul Oshige",
    loanType: "Personal Loan",
    image: "/assets/images/avatar/avater2.jpg",
  },
  {
    quote:
      "I had a good experience with Insight Loan Services. I am thankful to Insight for the help you guys gave me. My loan was easy and fast. Thank you Insight",
    name: "Roland Edema",
    loanType: "Education Loan",
    image: "/assets/images/avatar/avater1.jpg",
  },
  {
    quote:
      "We came out of their offices very happy with their service. They treated us very kind. Definitely will come back. The waiting time was very appropriate.",
    name: "Lucky Olarewaju",
    loanType: "Car Loan",
    image: "/assets/images/avatar/avater3.jpg",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials">
      <h2 className="testimonials-title">Some of our Awesome Testimonials</h2>
      <p className="testimonials-subtitle">You won’t be the only one.</p>
      <div className="testimonials-container">
        {testimonials.map((testimonial, index) => (
          <div key={index}>
            <div className="testimonial-card">
              <p className="testimonial-quote">“{testimonial.quote}”</p>
            </div>
            <div className="testimonial-user">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="testimonial-avatar"
              />
              <div className="testimonial-info">
                <h4>{testimonial.name}</h4>
                <p className="loan-type">{testimonial.loanType}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
